import React from 'react';
import SectionHeader from 'components/section-header/section-header';
import FrameworkIcons from './framework-icons';

export default function StorefrontCustomDocs() {
  return (
    <>
      <fieldset>
        <SectionHeader
          className="view-body-subtitle"
          title="Technologies"
          subtitle={
            <span>
              We recommend choosing a modern framework to build your storefront.
              Read our documentation for code examples and check out our
              storefront starter-kits{' '}
              <a
                href="https://developers.swell.is/storefronts/origin-headless"
                target="_blank"
                rel="noopener noreferrer"
              >
                <strong>Origin</strong>
              </a>{' '}
              and{' '}
              <a
                href="https://developers.swell.is/storefronts/horizon-headless"
                target="_blank"
                rel="noopener noreferrer"
              >
                <strong>Horizon</strong>
              </a>{' '}
              for more inspiration.
            </span>
          }
        />

        <div className="storefront-docs-section">
          <FrameworkIcons
            frameworks={[
              'vuejs',
              'react',
              'nuxtjs',
              'nextjs',
              'svelte',
              'nodejs',
              'php',
            ]}
          />

          <div>
            <a
              href="https://developers.swell.is/storefronts/headless-storefront-guide"
              target="_blank"
              className="view-link"
              rel="noreferrer"
            >
              Read the docs &rarr;
            </a>
          </div>
        </div>
      </fieldset>
    </>
  );
}
